import { SVGProps, Ref, forwardRef } from 'react';

export const BellFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M1.716 7.668c1.75-2.772 6.433-9.173 10.948-6.55 4.515 2.625 1.35 9.908-.16 12.82z"
            fill="currentColor"
        />
        <path
            d="M7.286 15.405c1.241.333 2.168-.264 2.813-1.246l-4.532-2.634c-.303 1.728.005 3.421 1.719 3.88"
            fill="currentColor"
        />
    </svg>
));
BellFilledSize16Glyph.displayName = 'BellFilledSize16Glyph';
